/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import ButtonAnchor from 'components/ButtonAnchor';
import Container from 'components/Container';
import PremiumAdvantageCard from 'components/PremiumAdvantageCard';
import React from 'react';
import { useIntl } from 'react-intl';
import { Advantage } from 'types/Advantage';
import { Application } from 'types/Application';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ApplicationDetailUseReasonsProps extends React.HTMLAttributes<HTMLDivElement> {
  application: Application;
  reasons: Advantage[];
}

const ApplicationDetailUseReasons = React.forwardRef<HTMLDivElement, ApplicationDetailUseReasonsProps>(
  ({ reasons, application }, ref) => {
    const intl = useIntl();
    const { buttons2 } = application;
    return (
      <ClassNames>
        {({ theme }) => (
          <Container maxWidth='lg'>
            <div
              ref={ref}
              css={{
                '@media(min-width: 960px)': {
                  padding: theme.spacing(4, 0),
                },
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                padding: theme.spacing(2, 0),
                width: '100%',
              }}
            >
              <div css={{ alignItems: 'stretch', display: 'flex', flexDirection: 'column' }}>
                <div
                  css={{
                    ...theme.typography.h2,
                    '@media(min-width: 960px)': {
                      padding: theme.spacing(0, 2),
                    },
                    alignSelf: 'flex-start',
                    marginBottom: theme.spacing(2),
                  }}
                >
                  {intl.formatMessage({
                    defaultMessage: 'Proč bych měl používat AppOn.cloud Premium?',
                    id: 'application.whytouse',
                  })}
                </div>
                <div
                  css={{
                    alignSelf: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  {reasons.map((reason, idx) => (
                    <PremiumAdvantageCard
                      css={{ background: '#eae9e9 !important', maxWidth: 285 }}
                      key={idx.toString()}
                      advantage={reason}
                    />
                  ))}
                </div>
                <div
                  css={{
                    '& > a': { margin: theme.spacing(2, 1) },
                    '@media(min-width: 600px)': {
                      '& > a': { margin: theme.spacing(2) },
                    },
                    '@media(min-width: 960px)': {
                      padding: theme.spacing(4),
                    },
                    alignItems: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                  }}
                >
                  {buttons2.map(({ href, text }, idx) => (
                    <ButtonAnchor key={idx.toString()} href={href} css={{ alignSelf: 'flex-start' }}>
                      {text}
                    </ButtonAnchor>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        )}
      </ClassNames>
    );
  },
);

export default ApplicationDetailUseReasons;

// const ApplicationDetailUseReasonsCard: React.FC = () => {
//   return (
//     <ClassNames>
//       {({ theme }) => (
//         <div
//           css={{
//             '@media(min-width: 960px)': {
//               height: `calc(200px - ${theme.spacing(2)})`,
//               width: `calc(200px - ${theme.spacing(2)})`,
//             },
//             '@media(min-width: 1180px)': {
//               height: 250,
//               width: 250,
//             },
//             alignItems: 'center',
//             background: theme.palette.secondary.main,
//             borderRadius: 3,
//             color: theme.palette.common.white,
//             display: 'flex',
//             height: `calc(150px - ${theme.spacing(2)})`,
//             justifyContent: 'center',
//             margin: theme.spacing(1),
//             padding: theme.spacing(1),
//             width: `calc(150px - ${theme.spacing(2)})`,
//           }}
//         >
//           TODO
//         </div>
//       )}
//     </ClassNames>
//   );
// };
